import React from 'react';
import { Flex, Text, Box } from 'rebass/styled-components';
import { ProfilePicture } from '@getro/rombo';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import PropTypes from 'prop-types';

export const ClaimHeader = ({ activeNetwork, company }) => (
  <Flex sx={{ flexDirection: 'column', gap: '16px' }}>
    <Flex sx={{ gap: '16px', alignItems: 'center' }}>
      <ProfilePicture
        width="48px"
        height="48px"
        variant="square"
        imageUrl={activeNetwork.logoUrl}
        name={activeNetwork.name}
        sx={{ flex: '0 0 auto' }}
      />
      <Flex
        sx={{
          flexDirection: 'column',
          width: '20px',
          svg: { color: 'neutral.400', width: '16px', height: '16px' },
        }}
      >
        <Box as={ArrowLeft} size="16px" />
        <Box as={ArrowRight} size="16px" sx={{ ml: '8px', mt: '-8px' }} />
      </Flex>
      <ProfilePicture
        width="48px"
        height="48px"
        variant="square"
        imageUrl={company?.logoUrl}
        name={company?.name}
        sx={{ flex: '0 0 auto' }}
      />
    </Flex>

    <Text fontSize="24px" fontWeight="700" color="text.dark" lineHeight="120%">
      Claim your company profile
    </Text>
    <Text sx={{ color: 'text.main', fontSize: '18px', fontWeight: '400' }}>
      Use {activeNetwork.name}&apos;s influence and exposure to promote and fill open roles.
    </Text>
  </Flex>
);

ClaimHeader.propTypes = {
  activeNetwork: PropTypes.object.isRequired,
  company: PropTypes.object.isRequired,
};
